import env from "../../utils/env";
const axios = require('axios');
 
const MAXRETRIES = 3;
const RETRYINTERVALS = [5000, 10000, 15000];
let refreshTokenRequestTime = new Date(2018, 11);
let isRefreshing = false;
let failedQueue = [];
 
const delay = t => new Promise(resolve => setTimeout(resolve, t));
 
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};
 
const HttpService = function ($http, AuthService, $q) {
  "ngInject"
 
  axios.interceptors.request.use(function (config) {
    if (!config.retries) config.retries = 0;
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
 
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    const originalRequest = error.config;
 
    if (error.response && error.response.status === 401 &&
      !originalRequest.url.endsWith('refreshtoken') && !originalRequest._retry) {
     
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({resolve, reject});
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axios.request(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }
 
      originalRequest._retry = true;
      isRefreshing = true;
 
      if (AuthService.getRefreshToken()) {
        return AuthService.refreshToken().then(() => {
          const newToken = AuthService.getAccessToken();
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          processQueue(null, newToken);
          isRefreshing = false;
          return axios.request(originalRequest);
        }).catch((err) => {
          processQueue(err, null);
          isRefreshing = false;
          AuthService.logout();
          return Promise.reject(err);
        });
      }
    }
    return Promise.reject(error);
  });
 
  // const refreshToken = () => {
  //   const payload = {
  //     refreshToken: AuthService.getRefreshToken()
  //   };
 
  //   return axios({
  //     method: "POST",
  //     url: env.getApiUrl("identity/refreshtoken"),
  //     data: payload
  //   })
  //   .then((response) => {
  //     AuthService.setAccessToken(response);
 
  //     return response;
  //   });
  // };
 
  const get = (path, successCallback, errorCallback) => {
    console.log("Get called::", path);
 
    axios({
      method: "GET",
      url: env.getApiUrl(path),
      headers: {
        "Authorization": `Bearer ${AuthService.getAccessToken()}`
      },
    })
    .then(successCallback).catch(errorCallback);
 
    // $http({
    //   method: "GET",
    //   url: env.getApiUrl(path),
    //   headers: {
    //     "Authorization": `Bearer ${AuthService.getAccessToken()}`
    //   },
    // })
    // .then(successCallback, (error) => {
    //   if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
    //     AuthService.refreshToken().then(() => {
    //       return get(path, successCallback, errorCallback);
    //     }).catch(errorCallback);
    //   }
    // });
  }
 
  const post = (path, payload, successCallback, errorCallback) => {
    console.log("Post called::", path, payload);
 
    $http({
      method: "POST",
      url: env.getApiUrl(path),
      data: payload,
      headers: {
        "Authorization": `Bearer ${AuthService.getAccessToken()}`
      },
    })
    .then(successCallback, (error) => {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(() => {
          return post(path, payload, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    });
  }
 
  const patch = (path, payload, successCallback, errorCallback) => {
    console.log("Patch called::", path, payload);
 
    $http({
      method: "PATCH",
      url: env.getApiUrl(path),
      data: payload,
      headers: {
        "Authorization": `Bearer ${AuthService.getAccessToken()}`
      },
    })
    .then(successCallback, (error) => {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(() => {
          return patch(path, payload, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    });
  }
 
  const deleteResource = (path, successCallback, errorCallback) => {
    console.log("Delete called::", path);
 
    $http({
      method: "DELETE",
      url: env.getApiUrl(path),
      headers: {
        "Authorization": `Bearer ${AuthService.getAccessToken()}`
      },
    })
    .then(successCallback, (error) => {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(() => {
          return deleteResource(path, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        errorCallback(error);
      }
    });
  }
 
  const getPromise = (path) => {
    console.log("Get promise called::", path);
 
    const deferred = $q.defer();
 
    axios({
      method: "GET",
      url: env.getApiUrl(path),
      headers: {
        "Authorization": `Bearer ${AuthService.getAccessToken()}`
      },
    })
    .then((response) => {
      deferred.resolve(response.data);
    }, (error) => {
      deferred.reject(error);
    });
 
    return deferred.promise;
  }
 
 
  return { get, post, patch, getPromise, deleteResource }
};
 
export default HttpService;
 


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/http.service.js
 **/